import { type ReactElement } from 'react';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';
import { useToast } from '@/hooks/useToast';

/**
 * Mounts a single `ToastProvider` + `ToastViewport` and renders every queued
 * toast. Place once near the root of the app (inside `AppLayout`) — anywhere
 * that calls `toast(...)` (imperative) or `useToast()` (hook) will route here.
 */
export function Toaster(): ReactElement {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map((t) => (
        <Toast
          key={t.id}
          open={t.open}
          {...(t.variant !== undefined ? { variant: t.variant } : {})}
        >
          <div className="flex-1 min-w-0 grid gap-1">
            {t.title !== undefined && <ToastTitle>{t.title}</ToastTitle>}
            {t.description !== undefined && (
              <ToastDescription>{t.description}</ToastDescription>
            )}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
